import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './taskComponent.module.css'
import { EditTaskModal } from './EditTaskModal.jsx'
import { DeleteTaskModal } from './DeleteTaskModal.jsx'
import { TaskList } from './TaskList.jsx'

export const TasksPanel = ({ eventId }) => {
	const dispatch = useDispatch()
	const [editingTask, setEditingTask] = useState(null)
	const [confirmDeleteId, setConfirmDeleteId] = useState(null)

	// useEffect(() => {
	// 	if (eventId) dispatch(getTasks(eventId))
	// }, [eventId, dispatch])

	const confirmDelete = () => {
		// dispatch(deleteTask(confirmDeleteId))
		setConfirmDeleteId(null)
	}

	return (
		<section className={styles.wrap}>
			<header className={styles.header}>
				<h2>Tasks</h2>
				{/* <p className={styles.subtle}>
					{tasks.length} {tasks.length === 1 ? 'task' : 'tasks'}
				</p> */}
			</header>
			{/* <TaskList
				tasks={tasks}
				setEditingTask={setEditingTask}
				setConfirmDeleteId={setConfirmDeleteId}
			/> */}

			{editingTask && (
				<EditTaskModal
					task={editingTask}
					setEditingTask={setEditingTask}
				/>
			)}

			{confirmDeleteId && (
				<DeleteTaskModal
					title="Delete task?"
					message="This action cannot be undone."
					onCancel={() => setConfirmDeleteId(null)}
					onConfirm={confirmDelete}
				/>
			)}
		</section>
	)
}
